import '../styles/app.scss';
import './_images';
import './_fonts';
import ToggleStickyHeader from './components/ToggleStickyHeader';
import HistoryNavigation from './components/HistoryNavigation';
import SearchForm from './components/SearchForm';
import BackToTop from './components/BackToTop';
import Resources from './components/Resources';
import NavigationMenu from './components/NavigationMenu';
import Gravity from './components/Gravity';
import GravityFormDropDown from './components/GravityFormDropDown';

document.addEventListener(
	'DOMContentLoaded',
	() => {
		console.log('App ready');
		NavigationMenu();
		Gravity();
		GravityFormDropDown();
		window.addEventListener("scroll" , ToggleStickyHeader);
		HistoryNavigation();
		BackToTop();
		Resources();
		const search_form = new SearchForm();
		search_form.init();
	},
	false
);
